import Nullstack from 'nullstack';
export default function IconMistOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-mist-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 5h9"
  }), "   ", Nullstack.element("path", {
    d: "M3 10h7"
  }), "   ", Nullstack.element("path", {
    d: "M18 10h1"
  }), "   ", Nullstack.element("path", {
    d: "M5 15h5"
  }), "   ", Nullstack.element("path", {
    d: "M14 15h1m4 0h2"
  }), "   ", Nullstack.element("path", {
    d: "M3 20h9m4 0h3"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}